// 価格表種別ID
export const PRICE_DETAIL_TYPE = {VEGETABLE:1, FLUIT:2, ELSE:3, NONE:0, CLEAR:-1};